module.exports = require("scryptsy");